import { message } from "antd";
import { getDataAdmin, loginAdmin } from "../../api";
import { setAdminEmail, setAdminEnterpiseid, setAdminName, setAdminType, setImgUrlEnterpise, setLoginUser, setNameEnterprise } from "./authSlice";

export const onLoginAdmin = (payload) => {
	return async (dispatch, getState) => {
		const response = await loginAdmin(payload.email, payload.password);
		console.log(response);
		if (response.status === 0) {
			dispatch(setLoginUser(response.payload));
			return true;
		} else {
			message.error("error en usuario o contraseña");
			return false;
		}
	};
};

export const onGetAdminInfo = () => {
	return async (dispatch, getState) => {
		if (localStorage.getItem("x-token")) {
			const response = await getDataAdmin();
			console.log("Admin Data: ", response);
			if (response.status === 0) {
				dispatch(setAdminType(response.payload.typeUser));
				dispatch(setAdminEmail(response.payload.email));
				dispatch(setAdminEnterpiseid(response.payload.enterprise._id));
				dispatch(setAdminName(response.payload.name));
				dispatch(setImgUrlEnterpise(response.payload.enterprise.imgUrl));
				dispatch(setNameEnterprise(response.payload.enterprise.name));
				return response;
			} else {
				message.error("error en la informacion del usuario contacta al administrador");
				return false;
			}
		} else {
			return false;
		}
	};
};
